/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Full_SetInputs */

const en_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Set`)
};

const es_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego completo`)
};

const fr_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensemble complet`)
};

const de_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Set`)
};

const ja_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フルセット`)
};

const zh_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全套`)
};

const ar_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طقم كامل`)
};

const id_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Lengkap`)
};

const it_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Completo`)
};

const ru_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полный комплект`)
};

const pt_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjunto Completo`)
};

const ko_val_full_set = /** @type {(inputs: Val_Full_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`풀세트`)
};

/**
* | output |
* | --- |
* | "Full Set" |
*
* @param {Val_Full_SetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_full_set = /** @type {((inputs?: Val_Full_SetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Full_SetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_full_set(inputs)
	if (locale === "es") return es_val_full_set(inputs)
	if (locale === "fr") return fr_val_full_set(inputs)
	if (locale === "de") return de_val_full_set(inputs)
	if (locale === "ja") return ja_val_full_set(inputs)
	if (locale === "zh") return zh_val_full_set(inputs)
	if (locale === "ar") return ar_val_full_set(inputs)
	if (locale === "id") return id_val_full_set(inputs)
	if (locale === "it") return it_val_full_set(inputs)
	if (locale === "ru") return ru_val_full_set(inputs)
	if (locale === "pt") return pt_val_full_set(inputs)
	return ko_val_full_set(inputs)
});